import React, { useState } from "react";
import "../styles/Faq.css";
import Faqimg from "../assets/images/FAQ.png";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What makes empower web solutions better than others?",
      answer:
        "Empower Web Solutions delivers customized, scalable, and cost-effective digital solutions with expert teams, global reach, and a proven track record of quality, innovation, and client satisfaction across diverse industries.",
    },
    {
      question: "Do you provide website maintenance and support after delivery?",
      answer:
        "Yes! We offer ongoing maintenance plans, including updates, backups, security checks, and content changes.",
    },
    {
      question: "Why should I hire a digital marketing agency?",
      answer:
        "A professional digital marketing agency helps your business improve online visibility, generate quality leads, increase traffic, and boost sales using proven marketing strategies.",
    },
    {
      question: "What services does a web development company provide?",
      answer:
        "A web development company designs and develops websites, e-commerce platforms, landing pages, and custom web applications that improve user experience and business performance.",
    },
    {
      question: "How can a digital marketing agency in Noida help my business?",
      answer:
        "A professional digital marketing agency in Noida can help your business generate leads, improve search rankings, run targeted advertising campaigns, and build a stronger online presence.",
    },
      {
      question: "How long does website development take?",
      answer:
        "The timeline depends on the project requirements, features, and complexity. A standard business website usually takes 1–3 weeks.",
    },
    
  ];

  return (
    <div className="faq-container">
      <div className="faq-left">
        
        <h2>Frequently Asked Questions</h2>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div
              className="faq-item"
              key={index}
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <div className="faq-question">
                {faq.question}
                <span
                  className={`arrow ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  &#9660;
                </span>
              </div>

              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="faq-right">
        <img src={Faqimg} alt="Digital Marketing FAQ" />
      </div>
    </div>
  );
};

export default Faq;
